const $ = require('jquery')
const moment = require('moment')
const Domain = location.href.indexOf('51ping') !== -1 ? '//w.51ping.com' : '//www.dianping.com'

let param = {
    ipCityCName: window._DP_HeaderData && window._DP_HeaderData.ipCityCName ? window._DP_HeaderData.ipCityCName : '',
    ipCityEName: window._DP_HeaderData && window._DP_HeaderData.ipCityEName ? window._DP_HeaderData.ipCityEName : ''
}

const CityLocation = () => {
    let popLastTime = window.localStorage.getItem('citypoptime')
    let popDurationTime = moment().subtract(1, 'd').format()
    let flag = true
    if (popLastTime) {
        flag = moment(popDurationTime).isAfter(popLastTime)
    }
    // 通过add方法 增加日期后判断与当前日期的时间差
    // 添加localstorage
    if (param.ipCityCName && param.ipCityEName && flag) {
        let cityPopHtml = ` <div id="city-location" class="city-location">
                                    <div class="browser-overlay"></div>
                                    <div id="browser-city" class="browser-city">
                                        <div class="city-img"></div>
                                        <div id="city-close" class="close"></div>
                                        <div class="text">定位显示您在${param.ipCityCName}，您可以</div>
                                        <div class="city-button">
                                            <a href="${Domain + '/' + param.ipCityEName}"><div class="newcity">切换到${param.ipCityCName}</div></a>
                                            <div class="countdown">继续浏览<span id="countnum" class="countnum">(10)</span></div>
                                        </div>
                                    </div>
                                </div>`
        $('#index-main').append(cityPopHtml)
        $('#city-close, .countdown').on('click', function(e) {
            window.localStorage.setItem('citypoptime', moment().format())
            clearInterval(tenSec)
            $($('#city-location'), $('#index-main')).remove()
        })
        // 倒计时
        let sec = 9
        let tenSec = setInterval(function() {
            $('#countnum').text('(' + sec + ')');
            sec--;
            if (sec < 0) {
                clearInterval(tenSec)
                $($('#city-location'), $('#index-main')).remove()
            }
        }, 1000)
    }
}
module.exports = CityLocation;



// WEBPACK FOOTER //
// ./src/pages/index/component/city-location.js